import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_MultiStationNotification } from "../shared/data.service";
import { MsNotificationAddComponent } from "../shared/ms-notification-add/ms-notification-add.component";
import { DialogService } from "primeng/dynamicdialog";
import { MsNotificationEditComponent } from "../shared/ms-notification-edit/ms-notification-edit.component";
import { ConfirmationService } from "primeng/api";
import { LocalstorageService, UserService } from "../../../../shared";
import { FacilityOrDistrictPopupComponent } from "../shared/facility-or-district-popup/facility-or-district-popup.component";

@Component({
	selector: "caass-ms-notification-by-role",
	templateUrl: "./ms-notification-by-role.component.html",
	styleUrls: ["./ms-notification-by-role.component.css"],
})
export class MsNotificationByRoleComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationNotification,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private userService: UserService,
		private localService: LocalstorageService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	10.15 Try to select a facility based on the last school that was selected
		//
		var lastSchool = this.localService.getItem("SchoolSelector_School");
		if (lastSchool != undefined && lastSchool.SchoolID != undefined) {
			this.LastSchoolID = lastSchool.SchoolID;
		}

		this.loadFacility();
	}

	///////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////

	user: any;
	LastSchoolID: number = -1;

	Facility: any;
	lstFacility: any = [];

	EmailTypeID: number = 1;
	lstEmailType: any = [
		{
			ID: 1,
			Desc: "Blocked Visitor Attempted to Enter",
		},
		{
			ID: 2,
			Desc: "Visitor is a Confirmed Offender",
		},
		{
			ID: 3,
			Desc: "Visitor Needs Verification",
		},
	];

	SelectedNotifyEmail: any;
	lstNotifyEmail: any = [];
	pagerows: any = 10;
	pagefirst: any = 0;

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "Email", header: "Email" },
		// { field: 'FacilityCount', header: '# of Facilities' },
		// { field: 'FacilityDesc', header: 'Facilities' },
	];

	FacilityLoading: boolean = false;
	TableLoading: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////

	loadFacility() {
		this.FacilityLoading = true;

		var result = this.visitorService.VisitorFacilitySelectList(this.LastSchoolID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				this.lstFacility.unshift({
					FacilityID: -1,
					FacilityName: "All",
				});

				this.Facility = this.lstFacility[0];

				for (var z = 0; z < this.lstFacility.length; z++) {
					var next = this.lstFacility[z];

					if (next.Selected == true) {
						this.Facility = next;
					}
				}

				this.loadTable();

				this.FacilityLoading = false;
			},
			(error) => {
				this.FacilityLoading = false;
			}
		);
	}

	loadTable() {
		this.errorMessage = "";

		this.TableLoading = true;

		var result = this.visitorService.NotificationByRoleSelectList(this.Facility.FacilityID, this.EmailTypeID);
		result.subscribe(
			(response) => {
				this.lstNotifyEmail = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////

	onRefresh() {
		this.loadTable();
	}

	onAdd() {
		this.errorMessage = "";

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(MsNotificationAddComponent, {
			header: "Add Email",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedNotifyEmail == undefined) {
			this.errorMessage = "Select an email to edit";
			return;
		}

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(MsNotificationEditComponent, {
			header: "Edit Email",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				NotifyEmailID: this.SelectedNotifyEmail.NotifyEmailID,
				FirstName: this.SelectedNotifyEmail.FirstName,
				LastName: this.SelectedNotifyEmail.LastName,
				Email: this.SelectedNotifyEmail.Email,
				OnBlocked: this.SelectedNotifyEmail.OnBlocked,
				OnConfirmedOffender: this.SelectedNotifyEmail.OnConfirmedOffender,
				OnNeedsVerification: this.SelectedNotifyEmail.OnNeedsVerification,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedNotifyEmail == undefined) {
			this.errorMessage = "Select an email to delete";
			return;
		}

		if (this.Facility.FacilityID > 0) {
			this.confirmationService.confirm({
				key: "byrole",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: `You are about to delete the email ${this.SelectedNotifyEmail.Email}. Are you sure you want to continue?.`,
				header: "Confirm Delete",
				icon: "fa",
				accept: () => {
					this.onDeleteDistrictCheck();
				},
			});
		} else {
			this.confirmationService.confirm({
				key: "byrole",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: `You have district selected so this will stop the email ${this.SelectedNotifyEmail.Email} from RECEIVING EMAILS for ANY FACILITY. Are you sure you want to continue?.`,
				header: "Confirm Delete",
				icon: "fa",
				accept: () => {
					this.onFinishDelete(-1);
				},
			});
		}
	}

	onDeleteDistrictCheck() {
		var ref = this.dialogService.open(FacilityOrDistrictPopupComponent, {
			header: "Confirm Delete",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				FacilityID: this.Facility.FacilityID,
				FacilityName: this.Facility.FacilityName,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response.Success == true) {
				this.onFinishDelete(response.FacilityID);
			}
		});
	}

	onFinishDelete(FacilityID) {
		this.Processing = true;

		var result = this.visitorService.NotificationDelete(this.SelectedNotifyEmail.NotifyEmailID, FacilityID);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.onRowUnselect(null);
					this.loadTable();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "byrole",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the email address: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////

	onFacilityChange(val) {
		this.Facility = val;

		this.loadTable();
	}

	onEmailTypeIDChange(val) {
		this.EmailTypeID = val;

		this.loadTable();
	}

	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedNotifyEmail = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedNotifyEmail = null;
	}
	onRowDblClick(NotifyEmail) {
		this.errorMessage = "";
		this.SelectedNotifyEmail = NotifyEmail;
		this.onEdit();
	}
	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////

	IsLoading() {
		return this.FacilityLoading == true || this.TableLoading == true || this.Processing == true;
	}

	IsDistrict() {
		if (this.Facility == undefined) {
			return false;
		}
		if (this.Facility != undefined && this.Facility.FacilityID <= 0) {
			return true;
		} else {
			return false;
		}
	}

	///////////////////////////////////////////////////
}
